import z from 'zod';

import type { CountryDto } from '@/services/ws-appnexus-proxy/src/main/resources/rest-api';
import { DeviceCategory } from '@/services/ws-clickstream-analytics/src/main/resources/rest-api';
import type { Dayjs } from '@/js/libs/dayjs';
import { optionSchema } from '@/js/libs/form';

import { TrafficDashboardSearchParamKeys, TrafficDashboardTabs } from './types';

export const searchParams = z.object({
  [TrafficDashboardSearchParamKeys.VIEW]: z.nativeEnum(TrafficDashboardTabs).optional(),
});

export const filterSchema = z.object({
  countries: z.array(optionSchema(z.custom<CountryDto>())),
  startDate: z.custom<Dayjs>().nullable(),
  endDate: z.custom<Dayjs>().nullable(),
  deviceCategories: z.array(optionSchema(z.nativeEnum(DeviceCategory))).optional(),
  domains: z.array(optionSchema(z.string())).optional(),
});

export type FormValues = z.infer<typeof filterSchema>;
